export default __webpack_public_path__ + "static/media/StatusDoctor.5d401bda.svg";